
import { getPost } from '@/api/post';
import { deletePostApply, getOwnPostApply } from '@/api/post-apply';
import { UserModule } from '@/store/user';
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import ApplyForm from '@/components/apply/form.vue';

@Component({
  name: 'AppEventDetail',
  components: {
    ApplyForm,
  },
})
export default class extends Vue {
  mounted() {
    this.getPost();
  }

  get fileUrl() {
    return `${process.env.VUE_APP_COMMON_API}/attached-file`;
  }

  get isLogined() {
    return UserModule.token;
  }

  private post: any = null;

  private postApply: any = null;

  private applyVisible = false;

  private getPost() {
    if (this.$route.params.postUid) {
      getPost(this.$route.params.postUid).then((res) => {
        this.post = res.data;
        if (this.isLogined) {
          this.getPostApply(res.data);
        }
      });
    } else {
      this.$router.push({ name: 'AppEventList' });
    }
  }

  /* eslint-disable */
  private getPostApply(post: any) {
    const listQuery = {
      page: 0,
      size: 10,
      postUid: post.uid,
    };
    getOwnPostApply(listQuery).then((res) => {
      this.applyVisible = true;
      this.postApply = res.data.content[0];
    });
  }
  /* eslint-enable */

  private isEnd() {
    if (!this.post.dataList[3].inputValue || !this.post.dataList[4].inputValue) return false;
    const today = moment();
    const startDay = moment(this.post.dataList[3].inputValue, 'YYYY-MM-DD');
    const endDay = moment(this.post.dataList[4].inputValue, 'YYYY-MM-DD').hours(23).minutes(59).seconds(59);
    return today.isSameOrAfter(startDay) && today.isSameOrBefore(endDay);
  }
}
